import React, { useState, useEffect } from 'react';
import { Phone, Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileOpen(false);
  };

  const navLinks = [
    { label: 'About', id: 'about' },
    { label: 'Services', id: 'options' },
    { label: 'Comparison', id: 'comparison' },
    { label: 'Contact', id: 'contact' },
  ];

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-black/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div
            className="flex items-center space-x-3 cursor-pointer"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            data-testid="navbar-logo"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_tint-masters-chi/artifacts/rl203nw7_IMG_0650.PNG"
              alt="Tint Garage Logo"
              className="h-14 w-auto"
            />
          </div>

          {/* Desktop Nav Links */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                data-testid={`nav-link-${link.id}`}
                className="text-gray-300 hover:text-white transition-colors duration-200 font-medium text-sm"
              >
                {link.label}
              </button>
            ))}
            <a href="tel:+17736902541" data-testid="navbar-phone-btn">
              <Button
                variant="outline"
                className="border border-gold-500/60 text-white hover:bg-gold-500/10 bg-transparent rounded-full px-5 py-2 text-sm font-medium transition-all duration-300"
              >
                <Phone className="w-4 h-4 mr-2 text-gold-500" />
                (773) 690-2541
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white"
            onClick={() => setMobileOpen(!mobileOpen)}
            data-testid="mobile-menu-toggle"
          >
            {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-black/95 backdrop-blur-md border-t border-white/10" data-testid="mobile-menu">
          <div className="px-4 py-4 space-y-3">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                className="block w-full text-left text-gray-300 hover:text-white py-2 font-medium"
              >
                {link.label}
              </button>
            ))}
            <a href="tel:+17736902541" className="block pt-2">
              <Button
                variant="outline"
                className="border border-gold-500/60 text-white hover:bg-gold-500/10 bg-transparent rounded-full px-5 py-2 text-sm font-medium w-full"
              >
                <Phone className="w-4 h-4 mr-2 text-gold-500" />
                (773) 690-2541
              </Button>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
